import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BaseApiService } from '@app/services/api/base.service';
import { isDevMode } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CareerMatchesService extends BaseApiService {
  constructor(http: HttpClient) {
    const apiBaseUrl = isDevMode() ? '/navigate-api' : environment.navigateApiUrl;
    super(http, apiBaseUrl);
  }

  getCareerMatches(): Observable<any> {
    return this.get<any>('career-recommendations');
  }
}
